interface ICreateContextEvent<TEventType extends string, TEventDetail> {
  eventType: TEventType;
  eventDetail: TEventDetail;
}

export function createContextEvent<TEventType extends string, TEventDetail>({
  eventType,
  eventDetail,
}: ICreateContextEvent<TEventType, TEventDetail>): CustomEvent<TEventDetail> {
  // INFO(kohearon): By default, an event dispatched inside a shadow root
  // will not be visible outside that shadow root. To make an event pass
  // through shadow DOM boundaries, you must set the composed property to
  // true. It's common to pair composed with bubbles so that all nodes in
  // the DOM tree can see the event.
  return new CustomEvent<TEventDetail>(eventType, { bubbles: true, composed: true, detail: eventDetail });
}
